<template>
    <div class="fhv-centent">
        <h4 class="title-topic">Wireless Mesh Network Setting 2.4GHz</h4>
        <el-alert title="It is forbidden to modify the MESH configuration in subRouter mode!" type="warning" show-icon
        :closable="false" v-if="$G_DEVICE_CFG.isSubRouter"></el-alert>
        <el-form 
        :model="meshForm"  
        label-width="180px" 
        label-position="left"
        class="fhv-form" 
        size="mini"
        :rules="formCheck" 
        ref="meshForm"
        :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"
        v-loading="getLoad"
        >
            <el-form-item label="Enable Mesh:">
                <el-switch v-model="meshForm.enanle" @change="meshSwitch"></el-switch>
            </el-form-item>
            <div v-if="meshForm.enanle">
                <el-form-item label="Mesh ID:" prop="meshID">
                    <el-input v-model.trim="meshForm.meshID" disabled></el-input>
                </el-form-item>
                <el-form-item label="Encryption :" >
                    <el-select v-model="meshForm.encrypt" style="width: 100%" placeholder="Please select Encryption" disabled>
                        <el-option label="NONE" value="0"></el-option>
                        <el-option label="WPA2(AES)" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Pre-Shared Key:" prop="psk" v-if="meshForm.encrypt != '0'">
                    <el-input :type="isShowKey ? 'text' : 'password'" v-model.trim="meshForm.psk" disabled>
                        <i slot="suffix" class="el-input__icon glyphicon  fhv-password" 
                        :class="[isShowKey ? 'glyphicon-eye-close' : 'glyphicon-eye-open']"
                        @click="isShowKey = !isShowKey"></i>
                    </el-input>
                </el-form-item>
                
             </div>
             <el-form-item>
                <el-button type="primary" @click="apply">Apply</el-button>
                <el-button type="primary" @click="refresh">Refresh</el-button>
             </el-form-item>
        </el-form>
    </div>
</template>

<script>
import sizeof from '@/util/jsCharLength.js'

    export default {
        data() {
            return {
                isShowKey:false,
                getLoad:false,
                meshForm:{
                    enanle:false,
                    meshID:"",
                    encrypt:"4",
                    psk:""
                },
                formCheck:{
                    meshID:[
                        { required: true, message: 'Mesh ID cannot be empty.', trigger: 'blur' },
                        { 
                            validator:(rule, value, callback) => {
                                if(sizeof(value,'utf-8') > 32 || sizeof(value,'utf-8') < 1)
                                    callback(new Error("Mesh ID length must be greater than 32 byte"))
                                else
                                    callback()
                            },
                            trigger: 'blur' 
                        }
                    ],
                    psk:[
                        { required: true, message: 'Pre-Shared Key cannot be empty.', trigger: 'blur' },
                        { 
                            validator:(rule, value, callback) => {
                                if(sizeof(value,'utf-8') > 62 || sizeof(value,'utf-8') < 8)
                                    callback(new Error("Pre-Shared Key length must be less than 8 greater than 62 byte"))
                                else
                                    callback()
                            },
                            trigger: 'blur' 
                        }
                    ]
                }
            }
        },
        beforeMount(){
            this.getData()
        },
        methods: {
            getData() {
                this.getLoad = true
                axios
                .post("/boafrm/fhWlanMesh",{CmdType:"GET_WLAN_MESH",wlIndex:'0'})
                .then((response)=>{
                    this.getLoad = false
                    if(response.data.ret == 0)
                    {
                        this.meshForm.enanle = response.data.mesh.enable
                        this.meshForm.meshID = response.data.mesh.meshID
                        this.meshForm.encrypt = response.data.mesh.encrypt + ''
                        this.meshForm.psk = response.data.mesh.psk
                    }
                    else
                        this.$message.error('Get Mesh Config Data Faild!')
                })
                .catch((error) => {
                    this.getLoad = false
                    this.$message.error('Get Mesh Config Data Faild!')
                }) 
            },
            setData() {
                const loadingInstance = this.$loading({lock: true})
                axios
                .post("/boafrm/fhWlanMesh",{
                    CmdType:"SET_WLAN_MESH",
                    enable:this.meshForm.enanle,
                    meshID:this.meshForm.meshID,
                    encrypt:this.meshForm.encrypt,
                    psk:this.meshForm.psk,
                    wlIndex:'0'
                })
                .then((response)=>{
                    setTimeout(()=>{
                        loadingInstance.close()
                        if(response.data.ret == 0)
                            this.$message.success('Set Mesh Config Data Successful!')
                        else
                            this.$message.error('Set Mesh Config Data Faild!')
                    },10000)
                })
                .catch((error) => {
                    setTimeout(()=>{
                        loadingInstance.close()
                        this.$message.error('Get Mesh Config Data Faild!')
                    },10000)
                }) 
            },
            apply(){
                this.$refs['meshForm'].validate((valid) => {
                    if (valid) {
                        this.setData()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            refresh(){
                 this.getData()
            },
            meshSwitch(val){
                if(!val)
                {
                    this.$confirm(
                        'Are you sure you want to turn off the mesh switch? This operation may cause your network to be interrupted!',
                        'Warning',
                        {
                            confirmButtonText: 'Confirm',
                            cancelButtonText: 'Cancel',
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.meshForm.enanle = false
                    })
                    .catch(() => {
                        this.meshForm.enanle = true
                    })
                }
                
            }
        },
    }
</script>

<style scoped>

</style>